
function LogoutSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1921_74079)">
        <path d="M11 13C11.55 13 12 13.45 12 14V19C12 19.55 11.55 20 11 20H1C0.45 20 0 19.55 0 19V1C0 0.45 0.45 0 1 0H11C11.55 0 12 0.45 12 1V6C12 6.55 11.55 7 11 7C10.45 7 10 6.55 10 6V2H2V18H10V14C10 13.45 10.45 13 11 13ZM19.92 10.38C19.87 10.5 19.8 10.61 19.7 10.71L15.7 14.71C15.51 14.9 15.26 15 14.99 15C14.44 15 13.99 14.55 13.99 14C13.99 13.73 14.1 13.48 14.28 13.29L16.57 11H10.98C10.43 11 9.98 10.55 9.98 10C9.98 9.45 10.43 9 10.98 9H16.57L14.28 6.71C13.89 6.32 13.89 5.69 14.28 5.3C14.67 4.91 15.3 4.91 15.69 5.3L19.69 9.3C19.98 9.58 20.06 10.02 19.91 10.39L19.92 10.38Z" fill="#A0A0A0"/>
      </g>
      <defs>
        <clipPath id="clip0_1921_74079">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export { LogoutSVG }